import classNames from 'classnames';
import { ForwardedRef, HTMLAttributes, ReactNode } from 'react';

import styles from '../../styles/themes/remax-theme.module.css';

interface RemaxThemeProps extends HTMLAttributes<HTMLDivElement> {
    className?: string | null;
    children: ReactNode;
}

function RemaxTheme({
    children,
    className = null,
    ref = null,
    ...props
}: RemaxThemeProps & { ref?: ForwardedRef<HTMLDivElement> | null }) {
    return (
        <div className={classNames([className, styles.container])} ref={ref} {...props}>
            {children}
        </div>
    );
}

export default RemaxTheme;
